import { usePartnerConfig } from '~/stores/usePartnerConfig';
import { LandingType } from '~/enums/LandingType';

export default defineNuxtRouteMiddleware((to, from) => {
  const { landing } = usePartnerConfig();

  const hasPartnerComponent = computed(() => {
    switch (landing.value) {
      case LandingType.SX:
        return false;
      case LandingType.BLACKPROXY:
        return false;
      case LandingType.NEXUS:
        return false;
      case LandingType.ANYPAGE:
        return false;
      case LandingType.AKENET:
        return true;
      case LandingType.ASOCKS:
        return true;
      default:
        return false;
    }
  })

  // if (!hasPartnerComponent.value) {
  //   return navigateTo('/')
  // }
})